export default {
  title: 'Disponibilità prenotazioni',
};
